<template>
  <section id="pricing-plan">
    <b-row class="auth-inner m-0">
      <navbarAds />
    </b-row>
    <!-- title text and switch button -->
    <div class="text-center">
      <h1>
        {{ $t("pricing.title") }}
      </h1>
      <p class="mb-1 pb-75">
        {{ $t("pricing.description") }}
      </p>
      <div class="d-flex align-items-center justify-content-center mb-1 pb-50">
        <h6 class="mr-1 mb-0">
          {{ $t("pricing.monthly") }}
        </h6>
        <b-form-checkbox
          id="priceSwitch"
          v-model="status"
          name="price-switch"
          value="annually"
          unchecked-value="monthly"
          switch
          @input="tooglePlan"
        />
        <h6 class="ml-50 mb-0">
          {{ $t("pricing.annually") }}
        </h6>
      </div>
    </div>
    <!--/ title text and switch button -->
    <!-- <SkeletonLoader /> -->
    <div
      v-if="monthlyplans.length === 0 || yearlyPlans.length === 0"
      style="height: 100vh"
    >
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
    <!-- pricing plan cards -->
    <b-row
      v-if="monthlyplans.length && yearlyPlans.length"
      class="pricing-card"
    >
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto d-flex align-items-center justify-content-center"
      >
        <b-col cols="10">
          <b-row
            class="mx-auto d-flex align-items-center justify-content-center"
          >
            <!-- Basic Plan -->
            <b-col
              v-for="(item, index) in monthlyPlanShow
                ? monthlyplans
                : yearlyPlans"
              :key="index"
              md="4"
            >
              <b-card align="center" class="pb-1">
                <!-- img -->
                <b-img
                  v-if="hotAirBallon"
                  :src="getImageForItem(index)"
                  class="mb-2 mt-1 w-25"
                  alt="basic svg img"
                />
                <!--/ img -->
                <h3>{{ item.name }}</h3>
                <b-card-text>
                  {{ $t("pricing.simple_start_for_everyone") }}
                </b-card-text>

                <!-- Plan fee -->
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <sup class="font-medium-1 font-weight-bold text-primary"
                      >$</sup
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-primary"
                    >
                      {{ monthlyPlanShow ? item.monthPrice : item.fee }}
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                      >/{{ $t("pricing.month") }}</sub
                    >
                  </div>
                  <small
                    v-show="!monthlyPlanShow"
                    class="annual-pricing text-muted"
                    >$ {{ item.yearPrice }} / {{ $t("pricing.year") }}</small
                  >
                </div>

                <b-list-group class="list-group-circle text-left">
                  <b-list-group-item>
                    <div>
                      {{
                        monthlyPlanShow
                          ? item.trackingLimit
                          : item.trackingLimit
                      }}

                      tracking per {{ item.isBank ? "month" : "day" }}
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  block
                  class="mt-2"
                  :variant="item.isSubscription ? 'outline-success' : 'primary'"
                  @click="handlePlanUpgrade(item)"
                >
                  {{
                    item.isSubscription
                      ? $t("pricing.plan")
                      : $t("pricing.upgrade")
                  }}
                </b-button>
              </b-card>
            </b-col>

            <!-- Platinum Plan -->
            <b-col md="4">
              <b-card align="center" class="pb-1">
                <!-- img -->
                <b-img
                  v-if="roketImage"
                  :src="roketImage"
                  class="mb-2 w-25"
                  alt="enterprise svg img"
                />
                <!--/ img -->
                <h3>{{ pricing.platinumPlan.title }}</h3>
                <b-card-text>{{ $t("pricing.big_organisations") }}</b-card-text>

                <!-- annual plan -->
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <sup class="font-medium-1 font-weight-bold text-primary"
                      >$Custom</sup
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-primary"
                    >
                      <!-- {{
                      monthlyPlanShow ? pricing.platinumPlan.monthlyPrice : pricing.platinumPlan.yearlyPlan.perMonth
                    }} -->
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                    ></sub>
                  </div>
                  <small
                    v-show="!monthlyPlanShow"
                    class="annual-pricing text-muted"
                  ></small>
                </div>
                <!--/ annual plan -->

                <b-list-group class="list-group-circle text-left">
                  <b-list-group-item>
                    <div>
                      contact us for more details
                      <!-- {{ monthlyPlanShow ? tlPlantinumMonthly : tlPlantinumAnnualy }} tracking per day -->
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <!-- plan benefit -->
                <!-- <b-list-group
                  v-for="(data, index) in pricing.platinumPlan.planBenefits"
                  :key="index"
                  class="list-group-circle text-left"
                >
                  <b-list-group-item>
                    <div v-if="data === 'companiess'">
                      {{ "Contact us for this plan" }}
                    </div>
                    <div v-else-if="data === 'unlimited_ocr_invoices'">
                      {{ "Contact us for this plan" }}
                    </div>
                    <div v-else>{{ "Contact us for this plan" }}</div>
                  </b-list-group-item>
                </b-list-group> -->
                <!--/ plan benefit -->

                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  block
                  class="mt-2"
                  variant="outline-primary"
                  @click="handlePlanUpgrade(item)"
                >
                  {{ $t("pricing.upgrade") }}
                </b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
    </b-row>
    <!--/ pricing plan cards -->

    <!--Footnote  -->
    <b-row>
      <b-col sm="10" md="12" offset-lg="2" lg="10" class="mx-auto"
        ><b>Note:</b> All prices are without VAT</b-col
      >
    </b-row>

    <!-- pricing free trial -->
    <div class="pricing-free-trial mt-5">
      <b-row>
        <b-col lg="10" offset-lg="3" class="mx-auto">
          <div class="pricing-trial-content d-flex justify-content-between">
            <div class="text-center text-md-left mt-3">
              <h3 class="text-primary">
                {{ $t("pricing.still_not_convinced") }}
                {{ $t("pricing.trial") }}
              </h3>
              <h5>{{ $t("pricing.full_access") }}</h5>
              <b-link
                to="/my-plans"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn btn-primary mt-2 mt-lg-3"
              >
                {{ $t("pricing.free_trial") }}
              </b-link>
            </div>

            <!-- images -->
            <b-img
              fluid
              :src="
                require('../assets/images/illustration/pricing-Illustration.svg')
              "
              class="pricing-trial-img"
              alt="svg img"
            />
            <!--/ images -->
          </div>
        </b-col>
      </b-row>
    </div>
    <!--/ pricing free trial -->

    <!-- pricing faq -->
    <!-- <div class="pricing-faq">
      <h3 class="text-center">
        FAQ's
      </h3>
      <p class="text-center">
        Let us help answer the most common questions.
      </p>
      <b-row class="py-2">
        <b-col
            lg="10"
            offset-lg="2"
            class="mx-auto"
        >
          <app-collapse
              accordion
              type="margin"
          >

            <app-collapse-item title="Lorem Ipsum?">
              Lorem Ipsum is simply a dummy text
            </app-collapse-item>
          </app-collapse>
        </b-col>
      </b-row>
    </div> -->
    <!--/ pricing faq -->
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BImg,
  BCardTitle,
  BCardText,
  BDropdown,
  BDropdownItem,
  BFormSelect,
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BNavbarNav,
  BNavForm,
  BCollapse,
  BNavItemDropdown,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import {
  BFormCheckbox,
  BCard,
  BListGroup,
  BListGroupItem,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import navbarAds from "./navbarAds.vue";
import useJwt from "@/auth/jwt/useJwt";
import axios from "@/libs/axios";
import router from "@/router";

/* eslint-disable global-require */
export default {
  components: {
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BCard,
    BBadge,
    BRow,
    BImg,
    BCol,
    BLink,
    BForm,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BDropdown,
    BFormSelect,
    BDropdownItem,
    BFormInput,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItemDropdown,
    BNavForm,
    BDropdownDivider,
    BAvatar,
    navbarAds,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      status: "monthly",
      monthlyPlanShow: true,
      plansPrice: [],
      monthlyplans: [],
      yearlyPlans: [],
      pricing: {
        platinumPlan: {
          title: "Platinum",
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 129,
          yearlyPlan: {
            perMonth: 149,
            totalAnual: 149 * 12,
          },
          planBenefits: [
            "companiess",
            "unlimited_ocr_invoices",
            "unlimited_space",
            "unlimited_digital_invoices",
            "click_monthly_vat_report",
            "yearly_reports",
          ],
          popular: false,
        },
      },
    };
  },
  created() {
    this.hotAirBallon = require("@/assets/images/illustration/hot-air-balloon.svg");
    this.helicolptorImage = require("@/assets/images/illustration/helicoptor.svg");
    this.aeroplanImage = require("@/assets/images/illustration/aeroplane-transport-svgrepo-com.svg");
    this.aeroplanJetImage = require("@/assets/images/illustration/aeroplane-plane-svgrepo-com.svg");
    this.roketImage = require("@/assets/images/illustration/rocket-svgrepo-com.svg");
    this.getPlansValues();
  },
  methods: {
    tooglePlan() {
      this.monthlyPlanShow = this.status === "monthly";
    },

    // get plans
    getPlansValues() {
      useJwt
        .getPlansPrices()
        .then((response) => {
          this.plansPrice = response.data;
          let filteredPlans = response.data.filter(
            (plan) => plan.name !== "PLATINIUM"
          );
          this.monthlyplans = filteredPlans.filter(
            (item) => item.planType === "MONTHLY"
          );
          this.yearlyPlans = filteredPlans.filter(
            (item) => item.planType === "YEARLY"
          );
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching prices",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
    handlePlanUpgrade(item) {
      router.push({ name: "login" });
      // let currentPlan = {...item}
      // currentPlan.isSubscription = true
      // axios
      //   .post('account/api/payment/create-payment', currentPlan, {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // assuming accessToken is correct
      //       'Content-Type': 'application/json',
      //     },
      //   })
      //   .then(res => {
      //     const successURL = res.data.redirectUrl
      //     window.open(successURL, '_blank')
      //   })
    },
    getImageForItem(index) {
      const images = [
        this.hotAirBallon,
        this.aeroplanImage,
        this.roketImage,
        this.aeroplanJetImage,
        this.helicolptorImage,
      ];
      return images[index % images.length];
    },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";

.navbar-desktop a {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
  color: #6e6b7b !important;
  padding-bottom: 0 !important;
}

@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
